import { AlertsNotificationsSection } from "./settings/AlertsNotificationsSection";
import { DangerZoneCard } from "./settings/DangerZoneCard";
import { EmailRulesCard } from "./settings/EmailRulesCard";
import { GmailLabelsCard } from "./settings/GmailLabelsCard";
import { HistoricalPullCard } from "./settings/HistoricalPullCard";
import { IntegrationGrid } from "./settings/IntegrationGrid";
import { LexofficeSettingsCard } from "./settings/LexofficeSettingsCard";
import { PasswordSection } from "./settings/PasswordSection";
import { SyncControlsSection } from "./settings/SyncControlsSection";

// ============================================================
// Settings Page — Thin wrapper composing all settings sections
// ============================================================

export function SettingsPage() {
	return (
		<div className="space-y-6 animate-fade-in">
			<h1 className="font-display text-2xl">Einstellungen</h1>

			{/* Synchronisierung */}
			<SyncControlsSection />
			<HistoricalPullCard />

			{/* Integrationen */}
			<IntegrationGrid />

			{/* E-Mail-Filterung */}
			<div className="space-y-4">
				<h2 className="font-display text-lg text-stone-800">
					E-Mail-Filterung
				</h2>
				<GmailLabelsCard />
				<EmailRulesCard />
			</div>

			{/* LexOffice */}
			<LexofficeSettingsCard />

			{/* Alerts & Benachrichtigungen */}
			<AlertsNotificationsSection />

			{/* Gefahrenzone */}
			<DangerZoneCard />

			{/* Profil */}
			<PasswordSection />
		</div>
	);
}
